import { render, staticRenderFns } from "./PageNotFoundView.vue?vue&type=template&id=490ba872&"
import script from "./PageNotFoundView.vue?vue&type=script&lang=ts&"
export * from "./PageNotFoundView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports